@use '../../../assets/styles/utilities.scss';

:host {
  display: block;
}

.popup-wrapper {
  display: grid;
  max-height: calc(100vh - 10rem);
  height: auto;
}

.popup-modal {
  display: grid;
  grid-template-rows: auto 1fr auto; // Header, Scrollable Body, Footer
  max-height: calc(100vh - 10rem);
  height: auto;
  background: white;

  .modal-header {
    padding: 1rem 2rem;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  }

  .modal-body {
    overflow-y: auto;
    padding: 1.25rem 2rem;
    min-height: 0; // Ensures overflow works in grid
  }

  .modal-footer {
    padding: 1rem 2rem;
    box-shadow: 0 -1px 4px rgba(0, 0, 0, 0.06); // subtle top shadow
  }
}
